import React from 'react';
import clsx from 'clsx';
import { List } from 'semantic-ui-react';
import formFieldType, { formFieldText } from '@/forms/helper';
import { propertiesWithValue } from '@/utils/resultsHelper';
import FormObjectInputs from '@/forms/objects/components/FormObjectInputs';
import events from '../../hooks/events';
import selectors from '../hooks/selectors';
import requestFieldComponents from '../helper';

const RequestObjectInputs = ({
  category,
  code,
  field,
  fields,
  section,
}) => {
  const state = selectors.useFormFields({ category, code, section });
  const updateProperties = events.useUpdateRequestFieldsProperties(category, { code });

  const onValueChange = (parent, child, value) => {
    const properties = propertiesWithValue(parent, propertiesWithValue(child, value));
    updateProperties({ properties, fields: [parent.name, child.name], entity: section });
  };

  return (
    <List className={clsx('aridhia-form-object-list', field.code)}>
      <FormObjectInputs
        category={category}
        code={code}
        component={(f) => requestFieldComponents[formFieldType(f)]}
        field={field}
        fields={fields}
        onChange={onValueChange}
        errors={state.saveErrors}
        section={section}
        text={(parent, child) => formFieldText(state.request, child, 'fields.', parent)}
      />
    </List>
  );
};

export default RequestObjectInputs;
